<template>
<Transition
    :show="showFlag"
    enter="transition-opacity duration-75 delay-300"
    enter-from="opacity-0"
    enter-to="opacity-100"
    leave="transition-opacity duration-150"
    leave-from="opacity-100"
    leave-to="opacity-0"
>
    <div v-if="showFlag" class="max-w-full mx-auto bg-white rounded-lg relative">
        <div class="px-4 py-5 border-b border-gray-200 sm:px-6 bg-ap-fs-primary">
            <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                <div class="ml-4 mt-4 flex justify-between w-full">
                    <div>
                        <h3 class="text-xl leading-6 font-medium text-gray-50">
                            {{ title }}
                        </h3>
                        <p class="mt-1 text-md text-gray-200" v-if="description">
                            {{ description }}
                        </p>
                    </div>
                    <div>
                        <slot name="header-right"></slot>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-4">
            <slot name="default"></slot>
        </div>

        <div v-if="hasFooterSlot" class="px-4 py-5 border-t border-gray-200 sm:px-6">
            <slot name="footer">
                Footer
            </slot>
        </div>
    </div>
</Transition>
</template>

<script>

export default {
    props: {
        title: { type: String },
        description: { type: String },
        showFlag: { default: true },
    },
    computed: {
        hasFooterSlot() {
            return !!this.$slots.footer;
        },
    },
    components: {

    },
};
</script>
